// extracted by mini-css-extract-plugin
module.exports = {"grid":"style__grid__3b6Q+","toggle":"style__toggle__Es8bs"};